<mbs-form-group class="mb-0 text-sm">
  <mbs-select [items]="items"
              [label]="label"
              [formControl]="control"
              [virtualScroll]="true"
              [loading]="loading"
              [bindLabel]="bindLabel"
              [appendTo]="appendTo"
              [clearable]="clearable"
              [searchable]="searchable"
              [placeholder]="placeholder"
              [isAutoWidth]="true"
              [isCheckboxSelect]="multiple"
              [isCounterShowing]="multiple && !!counterLabel"
              [labelForCounter]="counterLabel"
              [typeahead]="typeahead$"
              [multiple]="multiple"
              (clear)="clearEvent.next()"
              (close)="closeEvent.next()">
    @if (showAddNewButton && (permissionsEnum.ManageCompanies | can: 'read') && (permissionsEnum.AccessToAllCompanies | can: 'read')) {
      <ng-template #mbsSelectFooterTmp>
        <mbs-button [isCtrl]="true"
                    (click)="onAddCompanyButtonClick()">{{'shared:computers.addNewCompany' | i18next}}</mbs-button>
      </ng-template>
    }
  </mbs-select>
</mbs-form-group>
